import {Component, DestroyRef, ElementRef, HostListener, inject, Input, OnInit} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {Subject} from 'rxjs';
import {debounceTime, distinctUntilChanged, switchMap, tap} from 'rxjs/operators';
import {CompanySearchService} from '../../admin/company-search.service';

@Component({
  selector: 'company-search',
  templateUrl: './company-search.component.html',
  styleUrls: ['./company-search.component.scss'],
  standalone: false,
})
export class CompanySearchComponent implements OnInit {
  public searchCompanyName = '';
  public companies;
  public loading = false;

  @Input('onNewId')
  public onNewId: (number) => void;

  private destroyRef = inject(DestroyRef);
  private searchSubject = new Subject<string>();

  constructor(private companySearch: CompanySearchService, private hostElement: ElementRef) {}

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (this.companies && !this.hostElement.nativeElement.contains(event.target)) {
      this.companies = null;
    }
  }

  ngOnInit(): void {
    this.searchSubject
      .pipe(
        debounceTime(300),
        distinctUntilChanged(),
        tap(term => {
          if (!term) {
            this.companies = null;
            this.loading = false;
          } else {
            this.loading = true;
          }
        }),
        switchMap(term => this.companySearch.findCompanies(term)),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe(c => {
        this.companies = c?.results ?? [];
        this.loading = false;
      });
  }

  onInput() {
    this.searchSubject.next(this.searchCompanyName);
  }

  setCompany(company) {
    this.searchCompanyName = company.company_name;
    this.companies = null;
    if (this.onNewId) {
      this.onNewId(company.id);
    }
  }
}
